import React from "react";
import ReactApexChart from "react-apexcharts";
import {Card, Col} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import getChartColorsArray from "../../Common/ChartsDynamicColor";


const TopCashier = (props:any) =>{
    const {t} = useTranslation();
    const {cashiers, cashierTransactions, dataColors} = props;
    const series = [{
        name: t('Dashboard.transactions'),
        data:cashierTransactions,
    }];
    const colorsArray = getChartColorsArray(dataColors);

    const options = {
        chart: {
            type: "bar",
            height: 350,
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 4,
            },
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: "14px",
                },
            },
            title: {text: t('Dashboard.cashier_number')}
        },
        xaxis: {
            categories: cashiers,
            title: { text: t('Dashboard.transaction_count')},

        },
        colors: colorsArray
    };


    return (
        <React.Fragment>
            <Col xs={12} md={4}>
                <Card>
                 <Card.Body>
                     <Card.Title>
                         {t('Dashboard.top_cashier')}
                     </Card.Title>
                     {cashiers && cashierTransactions && <ReactApexChart options={options} series={series} type="bar" height={375} /> }
                 </Card.Body>
                </Card>

            </Col>
        </React.Fragment>
    )


}
export default TopCashier;